import React, { useState } from "react";
import { Form, Button, Modal, Checkbox, Message, Icon } from "semantic-ui-react";
import { determineWaterUnits } from "../../../../utils/dataAndFormulas/waterForms";
import { useLanguage } from "../../../../contexts";
import "./UpdateUnitsModal.scss";

export function UpdateUnitsModal(props) {
  const { show, onClose, onApply, currentUnits, registeredFields, isLoading } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [selectedFields, setSelectedFields] = useState({});
  const [fieldUnits, setFieldUnits] = useState({});

  const allWaterFields = [
    { key: "water_domestic_municipal_network", label: t("water_domestic_municipal_network") },
    { key: "municipal_network_water_production", label: t("municipal_network_water_production") },
    { key: "combined_municipal_network_water", label: t("combined_municipal_network_water") },
    { key: "water_cost_domestic_municipal_network", label: t("water_cost_domestic_municipal_network") },
    { key: "water_cost_municipal_network_production", label: t("water_cost_municipal_network_production") },
    { key: "water_cost_combined_municipal_network", label: t("water_cost_combined_municipal_network") },
    { key: "domestic_groundwater", label: t("domestic_groundwater") },
    { key: "groundwater_production", label: t("groundwater_production") },
    { key: "groundwater_combined", label: t("groundwater_combined") },
    { key: "domestic_groundwater_cost", label: t("domestic_groundwater_cost") },
    { key: "groundwater_production_cost", label: t("groundwater_production_cost") },
    { key: "groundwater_combined_cost", label: t("groundwater_combined_cost") },
    { key: "rainwater", label: t("rainwater") },
    { key: "surface_water", label: t("surface_water") },
    { key: "cost_surface_water", label: t("cost_surface_water") },
    { key: "reused_water", label: t("reused_water") },
    { key: "recycled_water", label: t("recycled_water") },
    { key: "steam_condensed_water", label: t("steam_condensed_water") },
  ];

  const waterFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allWaterFields;

  const handleFieldToggle = (fieldKey, checked) => {
    setSelectedFields(prev => ({ ...prev, [fieldKey]: checked }));
    if (checked && !fieldUnits[fieldKey]) {
      setFieldUnits(prev => ({ ...prev, [fieldKey]: currentUnits?.[fieldKey] || "" }));
    }
  };

  const handleUnitChange = (fieldKey, unit) => {
    setFieldUnits(prev => ({ ...prev, [fieldKey]: unit }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    const allUnits = {};
    waterFields.forEach(field => {
      allSelected[field.key] = true;
      allUnits[field.key] = currentUnits?.[field.key] || "";
    });
    setSelectedFields(allSelected);
    setFieldUnits(allUnits);
  };

  const handleDeselectAll = () => {
    setSelectedFields({});
  };

  const handleApply = () => {
    const unitsToApply = {};
    Object.keys(selectedFields).forEach(key => {
      if (selectedFields[key] && fieldUnits[key]) {
        unitsToApply[key] = fieldUnits[key];
      }
    });
    if (Object.keys(unitsToApply).length === 0) return;
    onApply(unitsToApply);
  };

  const selectedCount = Object.values(selectedFields).filter(Boolean).length;

  return (
    <Modal open={show} onClose={onClose} size="large" className="update-units-modal">
      {/* <Modal.Header>
        <Icon name="edit" />
        {t("update_units_in_forms") || "Modificar unidades en formularios existentes"}
      </Modal.Header> */}
      <Modal.Content scrolling>
        <div className="update-units-modal__title">{t("update_units_in_forms") || "Modificar unidades"}</div>
        {/* <Message info>
          <Message.Header>{t("select_fields_to_update") || "Selecciona los campos a modificar"}</Message.Header>
          <p>
            {t("update_units_description") ||
              "Selecciona los campos y las unidades que deseas aplicar a todos los formularios existentes del año."}
          </p>
        </Message> */}

        <div style={{ marginBottom: "15px" }}>
          <Button size="small" className="btn-select-all" onClick={handleSelectAll}>
            <Icon name="check square" /> {t("select_all") || "Seleccionar todos"}
          </Button>
          <Button size="small" className="btn-deselect-all" onClick={handleDeselectAll}>
            <Icon name="square outline" /> {t("deselect_all") || "Deseleccionar todos"}
          </Button>
          <span style={{ marginLeft: "15px", color: "#666" }}>
            {selectedCount} {t("fields_selected") || "campos seleccionados"}
          </span>
        </div>

        <Form>
          <div className="update-units-grid">
            {waterFields.map((field) => (
              <div key={field.key} className="update-unit-row">
                <Checkbox
                  checked={selectedFields[field.key] || false}
                  onChange={(_, data) => handleFieldToggle(field.key, data.checked)}
                  label={field.label}
                  className="field-checkbox"
                />
                {selectedFields[field.key] && (
                  <Form.Dropdown
                    placeholder={t("select_unit")}
                    options={determineWaterUnits(field.key)}
                    selection
                    search
                    compact
                    value={fieldUnits[field.key] || ""}
                    onChange={(_, data) => handleUnitChange(field.key, data.value)}
                    className="unit-dropdown"
                  />
                )}
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          onClick={handleApply}
          disabled={selectedCount === 0 || isLoading}
          loading={isLoading}
        >
          <Icon name="save" />
          {t("apply_to_forms") || `Aplicar a formularios (${selectedCount})`}
        </Button>
        <Button secondary onClick={onClose} disabled={isLoading}>
          {t("cancel")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
